module.exports = __webpack_public_path__ + "img/JND30S.png";